import { FC } from 'react';
import { TAddress } from '../address.component';
import { Box, IconButton } from '@mui/material';
import PushPinIcon from '@mui/icons-material/PushPin';
import { styled } from '@mui/material';
import { AddressField } from './addressField.component';
import { useTranslation } from 'react-i18next';

export const AddressHover: FC<TAddressHover> = (props) => {
  const {
    addressValue,
    addressNameField,
    register,
    readOnlyAddress,
    isPinnedButtonExists,
    handlePinClick,
    handleMouseEnter,
    handleMouseLeave,
  } = props;
  const { t } = useTranslation();

  return (
    <SWrapper isPinnedButtonExists={isPinnedButtonExists}>
      {isPinnedButtonExists && (
        <SPinButton
          onClick={handlePinClick}
          size='small'
          data-pin-button='true'
          title={t('order.pin_to_main_screen')}
        >
          <PushPinIcon />
        </SPinButton>
      )}
      <AddressField
        {...{
          register,
          addressNameField,
          addressValue,
          readOnly: readOnlyAddress,
          handleMouseEnter,
          handleMouseLeave,
        }}
      />
    </SWrapper>
  );
};

const SWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isPinnedButtonExists',
})(({ isPinnedButtonExists }: { isPinnedButtonExists: boolean }) => ({
  position: 'relative',
  ' & .addressField .MuiInputBase-root': {
    paddingRight: isPinnedButtonExists ? '30px' : '14px',
  },
}));

const SPinButton = styled(IconButton)({
  position: 'absolute',
  top: 15,
  right: 15,
  zIndex: 10,
});

type TAddressHover = Pick<
  TAddress,
  'addressValue' | 'addressNameField' | 'register' | 'readOnlyAddress' | 'isAddressPinned'
> & {
  handlePinClick: (event: React.MouseEvent) => void;
  handleMouseEnter: () => void;
  handleMouseLeave: (event?: React.MouseEvent) => void;
  isPinnedButtonExists: boolean;
};
